import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, Checkbox, FormControlLabel } from '@mui/material';
import GppMaybeIcon from '@mui/icons-material/GppMaybe'; // Or use HazardIcon if available

const DeleteMemberModal = ({ open, handleClose, handleDelete, userId }) => {
  const [consentChecked, setConsentChecked] = useState(false);

  // Reset consent checkbox when modal closes
  useEffect(() => {
    if (!open) {
      setConsentChecked(false);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-member-modal"
      aria-describedby="modal-to-confirm-member-deletion"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 480,
        bgcolor: 'background.paper',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        borderRadius: '16px',
        p: 4,
        outline: 'none',
      }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
          gap: '0.5rem',
          flexDirection: 'column',
        }}>
          <GppMaybeIcon sx={{ width: 60, height: 60, color: '#000000', mb: 2 }} />
          <Typography variant="body1" align="center" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>
            Are you sure you want to delete this Member you created?
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={consentChecked}
                onChange={(e) => setConsentChecked(e.target.checked)}
                sx={{
                  '&.Mui-checked': {
                    color: '#02042D',
                  },
                }}
              />
            }
            label={
              <Typography sx={{ fontSize: '0.875rem' }}>
                This will permanently delete all associated data.
              </Typography>
            }
          />
        </Box>

        <Box sx={{ display: 'flex', gap: '1rem', width: '100%' }}>
          <Button
            variant="outlined"
            onClick={handleClose}
            fullWidth
            sx={{
              color: "#02042D",
              borderColor: "gray",
              textTransform: "none",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "12.537px",
              "&:hover": {
                borderColor: "#02042D",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleDelete(userId);
              handleClose();
            }}
            disabled={!consentChecked}
            fullWidth
            sx={{
              bgcolor: "#02042D",
              color: "#FFF",
              textTransform: "none",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "12.537px",
              "&:hover": {
                bgcolor: "#010320",
              },
              "&.Mui-disabled": {
                bgcolor: "#e0e0e0",
                color: "#9e9e9e",
              },
            }}
          >
            Yes, delete this Member
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteMemberModal;
